import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, Zap, Wrench, BookOpen, Users } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPE_META = {
  guide: { label: 'Guidance', cls: 'bg-blue-500/15 text-blue-500', Icon: BookOpen },
  tool: { label: 'Tool Promo', cls: 'bg-emerald-500/15 text-emerald-500', Icon: Wrench },
  flash: { label: 'AI Flash Deal', cls: 'bg-amber-500/15 text-amber-500', Icon: Zap },
};

const DripCampaignPanel = ({ isDark }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/drip/overview`)
      .then((res) => setData(res.data))
      .catch(() => setError('Failed to load drip campaign'));
  }, []);

  if (error) return <p className="text-sm text-red-500" data-testid="drip-error">{error}</p>;
  if (!data) return <Loader2 className="w-5 h-5 animate-spin text-blue-500" />;

  return (
    <div data-testid="drip-panel">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-1">
        <h3 className={`text-lg font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
          Automatic 30-Day Drip
        </h3>
        <span className="px-2.5 py-1 rounded-full text-xs font-bold bg-emerald-500/15 text-emerald-500" data-testid="drip-status">
          ● Active — runs automatically
        </span>
      </div>
      <p className={`text-sm mb-4 ${isDark ? 'text-gray-400' : 'text-gray-500'}`}>
        Every new lead automatically receives this value series from RV Match A.I. — match guidance, advisor
        nudges, tool promotions and AI flash deals. Each send also appears in the lead's card under Email
        Communication.
      </p>
      <div className={`flex items-center gap-5 text-sm mb-5 ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>
        <span className="inline-flex items-center gap-1.5" data-testid="drip-enrolled">
          <Users size={14} className="text-blue-500" /> {data.enrolled} enrolled
        </span>
        <span>{data.unsubscribed} unsubscribed</span>
      </div>
      <div className="space-y-1.5">
        {data.steps.map((s) => {
          const meta = TYPE_META[s.type] || TYPE_META.guide;
          const Icon = meta.Icon;
          return (
            <div
              key={s.key}
              className={`flex items-center gap-3 p-2.5 rounded-lg border ${isDark ? 'bg-gray-800/60 border-gray-700' : 'bg-white border-gray-200'}`}
              data-testid={`drip-step-${s.key}`}
            >
              <span className={`w-14 shrink-0 text-center text-[11px] font-black rounded-md py-1 ${isDark ? 'bg-gray-700 text-gray-200' : 'bg-gray-100 text-gray-700'}`}>
                DAY {s.day}
              </span>
              <div className="flex-1 min-w-0">
                <p className={`text-sm font-medium truncate ${isDark ? 'text-gray-100' : 'text-gray-900'}`}>{s.subject}</p>
              </div>
              <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-bold shrink-0 ${meta.cls}`}>
                <Icon size={11} /> {meta.label}
              </span>
              <span className={`text-xs shrink-0 w-16 text-right ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>
                {s.sent_count} sent
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DripCampaignPanel;
